import { AxiosError } from "axios";
import lang from "../languages/en.json";

export interface ErrorResponse {
  statusCode: number;
  statusText?: string;
  message: string;
  isPending?: boolean;
  reasonCode?: string;
  traceId?: string;
}

const handleError = (error: AxiosError): ErrorResponse => {
  const { commonErrors } = lang;
  if (error.response) {
    console.log("=============Error Response==========", error);
    const { status, data } = error.response;
    const errMessage =
      (data as { message?: string }).message ||
      (data as { ErrorMessage?: string }).ErrorMessage;

    const errorMessages: Record<number, string> = {
      400: commonErrors.error400,
      401: commonErrors.error401,
      404: commonErrors.error404,
      500: commonErrors.error500,
      503: commonErrors.error503,
    };

    return {
      statusCode: status,
      message:
        typeof errMessage === "string"
          ? errMessage
          : (errorMessages[status] ?? commonErrors.unknownError),
      isPending: (data as { isPending?: boolean }).isPending,
      reasonCode:
        (data as { reasonCode?: string }).reasonCode ||
        (data as { code?: string }).code,
      traceId: (data as { traceId?: string }).traceId,
    };
  } else if (error.request) {
    console.log("=============Request Error==========", error);
    return {
      statusCode: error.request?.status ?? 0,
      statusText: error.request?.statusText,
      message: error?.message ?? commonErrors.noResponseError,
    };
  }
  console.log("=============Unhandled Exception==========", error.response);
  return {
    statusCode: typeof error.code === "number" ? error.code : 0,
    message: error.message ?? commonErrors.unknownError,
  };
};

export { handleError };
